import { create } from 'zustand';
import { devtools } from 'zustand/middleware';
import { immer } from 'zustand/middleware/immer';
import { LanguageAbbr, LanguageName } from 'components/commercetools-ui/molecules/header-language-toggle/types';
import { getLocalizationInfo, LocalizationMapping } from 'project.config';

export type Locale = 'en' | 'es';

type LanguageState = {
  currentLanguage: LanguageAbbr;
  currentLanguageName: LanguageName;
  locale: Locale;
};

type LanguageAction = {
  getLocaleInfo: () => LocalizationMapping;
  getLanguageToDisplay: () => { languageAbbr: LanguageAbbr; languageName: LanguageName };
  setLocale: (locale: Locale) => void;
  updateLanguageInfo: () => void;
};

const defaultState: LanguageState = {
  currentLanguage: 'EN',
  currentLanguageName: 'English',
  locale: 'en', //by-default english language
};

export const useLanguageStore = create<LanguageState & LanguageAction>()(
  devtools(
    immer((set, get) => ({
      ...defaultState,
      updateLanguageInfo() {
        set((state) => {
          state.currentLanguage = state.locale === 'es' ? 'ESP' : 'EN';
          state.currentLanguageName = state.locale === 'es' ? 'Español' : 'English';
        });
      },

      setLocale(locale) {
        set((state) => {
          state.locale = locale;
        });
        get().updateLanguageInfo();
      },

      getLocaleInfo() {
        const state = get();
        return state.currentLanguage === 'EN' ? getLocalizationInfo('en') : getLocalizationInfo('es');
      },

      getLanguageToDisplay() {
        const state = get();
        const languageAbbr = state.currentLanguage === 'EN' ? 'ESP' : 'EN';
        const languageName = state.currentLanguageName === 'English' ? 'Español' : 'English';
        return { languageAbbr, languageName };
      },
    })),
    {
      name: 'Language Store',
      enabled: true,
    },
  ),
);
